'use strict';


export default function(opts) {
	return function() {
		return {
			template: `
			<div class="action-toolbar-icon">
				<i class="material-icons">${opts.icon}</i>
			</div>
			<div class="action-toolbar-text">
				${opts.text}
			</div>`,
			link: postLink,
		};

		function postLink(scope, element, attrs) {
			element.addClass('action-toolbar-item');
		}
	}
}
